// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sd-ms-room{display:flex;height:180px}.sd-ms-room .left{width:40%;border-right:1px solid #3ab0e3;padding-right:10px;height:100%;overflow-y:auto}.sd-ms-room .right{width:60%;height:100%}.form-bottom{margin-bottom:0!important;text-align:center}.el-input-number{width:100%}.div-check{padding:0 40px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
